/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantRegisterDto = {
  /**
   * Tenant name.
   */
  name: string;
  /**
   * Tenant registration number.
   */
  registrationNumber: string;
  /**
   * Contact email of the tenant.
   */
  email: string;
  userName: string;
  userSurname: string;
  /**
   * Admin user email
   */
  userEmail: string;
  /**
   * Default locale for tenant users.
   */
  userLocale?: TenantRegisterDto.userLocale;
  /**
   * Default locale for tenant clients.
   */
  clientLocale?: TenantRegisterDto.clientLocale;
};
export namespace TenantRegisterDto {
  /**
   * Default locale for tenant users.
   */
  export enum userLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Default locale for tenant clients.
   */
  export enum clientLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

